@if (variant() !== 'accessory') {
  <a
    [cmsRouterLink]="product().url"
    [innerHTML]="product().name | safeHtml"
  ></a>
} @else {
  <span [innerHTML]="product().name | safeHtml"></span>
}
<ng-content></ng-content>
